import {
  ADD_USEFUL_LINK,
  GET_USEFUL_LINKS,
  EDIT_USEFUL_LINK_BY_ID,
  REMOVE_USEFUL_LINK_BY_ID,
} from "../actions/useful-links-actions";
import { ApiRequestState } from "../../types/state-management";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const usefulLinksReducer = (
  state = initialState,
  action: any
): ApiRequestState => {
  switch (action.type) {
    case (ADD_USEFUL_LINK.REQUEST,
    GET_USEFUL_LINKS.REQUEST,
    EDIT_USEFUL_LINK_BY_ID.REQUEST,
    REMOVE_USEFUL_LINK_BY_ID.REQUEST):
      return {
        ...state,
        loading: true,
        error: null,
      };
    case (ADD_USEFUL_LINK.SUCCESS,
    GET_USEFUL_LINKS.SUCCESS,
    EDIT_USEFUL_LINK_BY_ID.SUCCESS,
    REMOVE_USEFUL_LINK_BY_ID.SUCCESS):
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case (ADD_USEFUL_LINK.FAILURE,
    GET_USEFUL_LINKS.FAILURE,
    EDIT_USEFUL_LINK_BY_ID.FAILURE,
    REMOVE_USEFUL_LINK_BY_ID.FAILURE):
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export { usefulLinksReducer };
